// extracted by mini-css-extract-plugin
export default {"button":"Bp-z","reviewSort":"Cp-z"};